<template>
  <tfoot>
    <tr>
      <td @click="clickHandler" class="_total">
        <v-icon class="icon" v-if="!isExcel">
          {{checkDate('total') ? up : down}}
        </v-icon>
        <div class="total_text">합계</div>
      </td>
      <th v-for="(data, i) in _total" :key="i">
        <div class="bot_dataWrap">
          {{i === 2 ? data : parseDataType(data)}}
        </div>
      </th>
    </tr>
    <template v-if="viewSubList()">
      <tr v-for="(data, index) in totalList" :key="index">
        <td :class="[tab == 'creative' ? '_creative_name' : '']">
          <div class="subText">{{!isExcelAndSize ? subListName(data) : subListName(data) + ' ' + data.ad_knd_nm}}</div>
        </td>
        <td v-for="(name, n) in dataList" :key="n" class="dataTd">
          <div class="bot_dataWrap">
            {{name === 'ctr' ? data[name].toFixed(2) : name === 'budget_amt' ? parseDataType(getBudgetAmt(campaginDaysData, name, data)) : parseDataType(data[name])}}
          </div>
        </td>
      </tr>
    </template>
  </tfoot>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {parseDataType, subListName, getBudgetAmt} from '@/assets/func'

  export default {
    name: 'days_total',
    props: {
      // data props
      adInfo: Array,
      dataInfo: Array,
      isExcel: Boolean,
      tab: String,
      campaginDaysData: Array,
      // function props
      checkDate: Function,
      clickDate: Function
    },
    data () {
      const getDataList = this.tab === 'contract' || this.tab === 'creativeGroup' ? ['imp_cnt', 'click_cnt', 'ctr', 'budget_amt'] : ['imp_cnt', 'click_cnt', 'ctr']
      return {
        dataList: getDataList,
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up'
      }
    },
    methods: {
      parseDataType (x) {
        return parseDataType(x)
      },
      getBudgetAmt (x, y, z) {
        return getBudgetAmt(x, y, z)
      },
      clickHandler () {
        // if (this.isExcel) return
        this.clickDate('total')
      },
      viewSubList () {
        // if (this.isExcel) return true
        return this.checkDate('total')
      },
      subListName (info) {
        return subListName(info, this.tab)
      }
    },
    computed: {
      ...mapState({
        currentAdKnd: state => state.campaign.currentAdKnd
      }),
      ...mapGetters([
        'daysImpTotal'
      ]),
      isExcelAndSize () {
        return (this.tab === 'size' || this.tab === 'geo')// && this.isExcel
      },
      _total () {
        if (this.tab === 'size' || this.tab === 'geo') {
          // if (!this.isExcel) {
          return (this.daysImpTotal(this.tab)[this.currentAdKnd])
          // } else {
          // let imp = 0
          // let click = 0
          // let ctr = 0
          // for (let i = 0; i < this.adInfo.length; i++) {
          //   let name = this.adInfo[i].ad_knd_nm
          //   if (this.daysImpTotal(this.tab)[name] === undefined) return [0, 0, 0]
          //   imp += this.daysImpTotal(this.tab)[name][0]
          //   click += this.daysImpTotal(this.tab)[name][1]
          // }
          // ctr = click / imp * 100
          // ctr = isNaN(ctr) ? 0 : ctr.toFixed(2)

          // return [imp, click, ctr]
        }
        // }
        return this.daysImpTotal(this.tab)
      },
      totalList () {
        // if ((this.tab === 'size' || this.tab === 'geo') && !this.isExcel) {
        if ((this.tab === 'size' || this.tab === 'geo')) {
          let currentAdKnd = this.currentAdKnd
          let res = this.dataInfo.filter(function (data) {
            return data.ad_knd_nm === currentAdKnd
          })
          return res
        }
        return this.dataInfo
      }
    }
  }
</script>

<style scoped>
  tfoot tr:first-child {
    background: #fff;
  }
  tr {
    background: rgb(242, 243, 245);
  }
  td {
    height: 25px;
  }
  ._creative_name {
    min-width: 170px;
    max-width: 170px;
    text-align: left;
  }
  ._total {
    padding-left: 30px;
  }
  .icon {
    vertical-align: middle;
    color: #689f38;
    font-weight: bold;
    position: absolute;
    left: 10px;
  }
  .total_text {
    display: inline-block;
    font-weight: bold;
  }
  ._total:hover {
    cursor: pointer;
  }

  .subText {
    margin-left: 30px;
  }
  .subText {
    text-align: left;
  }
  ._total {
    height: 25px;
    text-align: left;
  }
  ._creative_name .subText {
    margin-left: 0 !important;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 5px;
  }
  tfoot td, tfoot th {
    border-top: 1px solid #eaeaea
  }
  @media screen and (max-width: 600px) {
    .icon {
      margin-left: -5px;
    }
    ._total {
      text-align: left;
    }
  }
  @media screen and (max-width: 350px) {
    ._creative_name {
      min-width: 155px;
      max-width: 155px;
    }
  }
</style>



// WEBPACK FOOTER //
// DaysTotal.vue?7467a3f1